import { Slide } from 'components/UI/V2/Carousel/Slide';

const IMAGE_VIDEO = 'images/sliders/placeholder-video.png';

const pricingOptionsHTML = `
<Box>
    <p style="font-weight: 500; font-size: 18; margin-top: 0; margin-bottom: 15px;">Pick one of these options:</p>

    <Box style="margin-bottom: 10px; display: flex; align-items: flex-start;">
        <Box style="margin-right: 10px; margin-top: 2px;">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="20"><path fill="#92B4A7" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path></svg>
        </Box>
        <Box>
            <Box style="font-weight: 600;">Fixed Price:</Box>
            <Box style="color: #555; font-size: 14px;">A single rate for all pets.</Box>
        </Box>
    </Box>

    <Box style="margin-bottom: 10px; display: flex; align-items: flex-start;">
        <Box style="margin-right: 10px; margin-top: 2px;">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="20"><path fill="#92B4A7" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path></svg>
        </Box>
        <Box>
            <Box style="font-weight: 600;">By Pet Size:</Box>
            <Box style="color: #555; font-size: 14px;">Different rates based on the pet's size.</Box>
        </Box>
    </Box>

    <Box style="margin-bottom: 15px; display: flex; align-items: flex-start;">
        <Box style="margin-right: 10px; margin-top: 2px;">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="20"><path fill="#92B4A7" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path></svg>
        </Box>
        <Box>
            <Box style="font-weight: 600;">By Pet Size & Hair Length:</Box>
            <Box style="color: #555; font-size: 14px;">Further customize your rates based on both size and hair length.</Box>
        </Box>
    </Box>

    <Box style=" border: 2px solid #BCB8AE; padding: 10px 15px; display: flex; border-radius: 12px;">
        <svg style="margin-top: 5px; display: flex; align-items: center; justify-content: center; width: 40px; height: 20px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="40"><path fill='#BAA997' d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>
        <Box style="font-size: 14px; color: #333; margin-left: 8px;">
            You can update pet sizes at any time in <strong>Settings > Pet Types</strong>.
        </Box>
    </Box>
</Box>
`;

export const serviceSlides: Slide[] = [
    {
        id: 1,
        stepNumber: 1,
        title: 'Add your grooming services.',
        description:
            'Begin by adding your core grooming services — give them memorable names and short, compelling descriptions.',
        image: 'images/sliders/service/slider-service-1.jpg',
        videoThumbnail: IMAGE_VIDEO,
        videoTitle: 'How to add a service?',
        videoDuration: '1:18',
        videoUrl: 'https://www.loom.com/share/7918ddbdd4764fe7a66bc5caa0bcf7b1'
    },
    {
        id: 2,
        stepNumber: 2,
        title: 'Input the service duration.',
        description: `<Box>Set how long the service will take. You can choose a fixed duration or tailor it by pet size for efficient scheduling. </Box>
            <Box style="margin-top: 15px; border: 2px solid #BCB8AE; padding: 10px 15px; display: flex; border-radius: 12px;">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="28"><path fill='#BAA997' d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>
                <Box style="font-size: 14px; color: #333; padding-left: 10px;">
                    You can update pet sizes at any time in <strong>Settings > Pet Types</strong>.
                </Box>
            </Box>`,
        image: 'images/sliders/service/slider-service-2.jpg',
        videoThumbnail: IMAGE_VIDEO,
        videoTitle: 'How to add a service?',
        videoDuration: '1:18',
        videoUrl: 'https://www.loom.com/share/7918ddbdd4764fe7a66bc5caa0bcf7b1'
    },
    {
        id: 3,
        stepNumber: 3,
        title: 'Set your pricing.',
        description: pricingOptionsHTML,
        image: 'images/sliders/service/slider-service-3.jpg',
        videoThumbnail: IMAGE_VIDEO,
        videoTitle: 'How to add a service?',
        videoDuration: '1:18',
        videoUrl: 'https://www.loom.com/share/7918ddbdd4764fe7a66bc5caa0bcf7b1'
    },
    {
        id: 4,
        stepNumber: 4,
        title: 'Assign staff to the service.',
        description:
            'Select the staff members who can perform this service, so they appear as options when making a booking.',
        image: 'images/sliders/service/slider-service-4.jpg',
        videoThumbnail: IMAGE_VIDEO,
        videoTitle: 'How to add a service?',
        videoDuration: '1:18',
        videoUrl: 'https://www.loom.com/share/7918ddbdd4764fe7a66bc5caa0bcf7b1'
    }
];
